import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs) {
    return twMerge(clsx(inputs));
}

export default function Navbar() {
    const [scrolled, setScrolled] = useState(false);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 50);
        };
        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <>
            <nav
                className={cn(
                    "fixed top-6 left-1/2 -translate-x-1/2 z-50 w-[90%] max-w-5xl rounded-[3rem] transition-all duration-500 flex items-center justify-between px-6 py-4",
                    scrolled
                        ? "bg-background/80 backdrop-blur-xl border border-dark/10 shadow-lg"
                        : "bg-transparent"
                )}
            >
                <div className="flex items-center gap-2">
                    <span className={cn(
                        "font-heading font-bold text-xl tracking-tight transition-colors duration-500",
                        scrolled ? "text-primary" : "text-background"
                    )}>
                        ROSSIEAU
                    </span>
                    <span className={cn(
                        "text-sm tracking-wide transition-colors duration-500 hidden sm:inline-block",
                        scrolled ? "text-accent" : "text-background/80"
                    )}>creative concepts</span>
                </div>

                {/* Desktop Links */}
                <div className={cn(
                    "hidden md:flex items-center gap-8 font-medium text-sm transition-colors duration-500",
                    scrolled ? "text-dark" : "text-background"
                )}>
                    <a href="#expertise" className="hover-lift hover:text-accent">Expertise</a>
                    <a href="#portfolio" className="hover-lift hover:text-accent">Portfolio</a>
                    <a href="#philosophy" className="hover-lift hover:text-accent">Philosophy</a>
                    <a href="#protocol" className="hover-lift hover:text-accent">Protocol</a>
                </div>

                <button className={cn(
                    "hidden md:inline-flex items-center justify-center px-6 py-2 rounded-full text-sm font-bold magnetic-btn transition-colors duration-500",
                    scrolled
                        ? "bg-accent text-background hover:bg-primary"
                        : "bg-background text-primary hover:bg-accent hover:text-background"
                )}>
                    Book a meeting
                </button>

                {/* Mobile Toggle */}
                <button
                    className={cn("md:hidden p-2 transition-colors", scrolled ? "text-dark" : "text-background")}
                    onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                >
                    {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
                </button>
            </nav>

            {/* Mobile Menu */}
            {mobileMenuOpen && (
                <div className="fixed inset-0 z-40 bg-background/95 backdrop-blur-3xl flex flex-col items-center justify-center gap-8 pt-20">
                    <a href="#expertise" className="text-2xl font-heading text-dark hover:text-accent" onClick={() => setMobileMenuOpen(false)}>Expertise</a>
                    <a href="#portfolio" className="text-2xl font-heading text-dark hover:text-accent" onClick={() => setMobileMenuOpen(false)}>Portfolio</a>
                    <a href="#philosophy" className="text-2xl font-heading text-dark hover:text-accent" onClick={() => setMobileMenuOpen(false)}>Philosophy</a>
                    <a href="#protocol" className="text-2xl font-heading text-dark hover:text-accent" onClick={() => setMobileMenuOpen(false)}>Protocol</a>
                    <button className="px-8 py-3 rounded-full text-lg font-bold bg-accent text-background mt-4">
                        Book a meeting
                    </button>
                </div>
            )}
        </>
    );
}
